import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    label: "电影",
    desc: "院线新片 · 经典佳作",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20theater%20interior%20with%20rows%20of%20empty%20red%20seats%20and%20warm%20projector%20light%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20moody%20atmosphere%2C%20cinematic%20wide%20shot%2C%20highly%20detailed&width=800&height=500&seq=quickmovie&orientation=landscape",
  },
  {
    to: "/category/tv",
    label: "电视剧",
    desc: "热播剧集 · 全集在线",
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20living%20room%20with%20a%20glowing%20tv%20screen%20at%20night%20and%20warm%20lamplight%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20cinematic%20mood%2C%20highly%20detailed%20interior%20photography&width=800&height=500&seq=quicktv&orientation=landscape",
  },
];

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 pt-12 md:px-8 md:pt-16">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative h-40 cursor-pointer overflow-hidden rounded-lg md:h-48"
          >
            <img
              src={entry.image}
              alt={`${entry.label}分类入口`}
              title={`${entry.label}分类 - 97影院`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 to-primary-950/30" />
            <div className="absolute inset-0 flex items-center justify-between px-6 md:px-8">
              <div>
                <div className="flex items-center gap-2 text-background-50">
                  <i className={`${entry.icon} text-2xl text-accent-400`} />
                  <span className="font-heading text-2xl font-bold md:text-3xl">{entry.label}</span>
                </div>
                <p className="mt-2 text-sm text-background-200">{entry.desc}</p>
              </div>
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-primary-950 transition-transform group-hover:translate-x-1">
                <i className="ri-arrow-right-line text-xl" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}